import { ClipboardList } from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { OrdersBoard } from "@/components/orders/OrdersBoard";
import { EmptyState } from "@/components/common/Primitives";
import { useAuth } from "@/context/AuthContext";

const NAV = [{ to: "/staff", key: "staff-orders", label: "Orders", icon: ClipboardList, end: true }];

export default function StaffTerminal() {
  const { user } = useAuth();
  const allowed = (user?.permissions || []).includes("orders");
  return (
    <DashboardLayout nav={NAV}>
      {allowed ? <OrdersBoard /> : (
        <EmptyState icon={ClipboardList} title="No order access" description="Ask your restaurant owner to grant you order permissions." testId="staff-no-permission" />
      )}
    </DashboardLayout>
  );
}
